<template>
  <div>
    <el-dialog
      title="移动到分组"
      :visible.sync="editdialog"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="grouplist">
        <div class="title">
          <span>分组名称</span>
          <span>商品数量</span>
        </div>
        <div
          class="item"
          v-for="(item,index) in options"
          :key="index"
          @click="choose(item.group_id,index)"
        >
          <div>{{item.group_name}}</div>
          <div>{{item.goods_count}}</div>
        </div>
        <div style="text-align:right;margin-top:20px">
          <el-button
            type="primary"
            @click="submit"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="container">
      <div class="searchbox">
        <span>
          <span>所属分组</span>
          <el-select
            v-model="group_id"
            multiple
            placeholder="请选择"
            style="width:300px;margin-left:10px"
            @change="search"
          >
            <el-option
              v-for="item in options"
              :key="item.group_id"
              :label="item.group_name"
              :value="item.group_id"
            ></el-option>
          </el-select>
        </span>
        <el-button
          type="primary"
          style="width:140px"
          @click="editGroup"
        >移动到分组</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6;">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;min-width:1000px;"
          :header-cell-style="{background:'#F5F5F5'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection"></el-table-column>

          <el-table-column
            label="商品分组"
            prop="group_name"
          ></el-table-column>
          <el-table-column label="商品主图">
            <template slot-scope="scope">
              <div>
                <img
                  :src="scope.row.goods_thumb"
                  alt
                  style="width:100%;max-height:200px"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            prop="goods_title"
          ></el-table-column>
          <el-table-column
            label="商品ID"
            prop="goods_id"
          ></el-table-column>
          <el-table-column label="组内排序">
            <template slot-scope="scope">
              <el-button
                @click="updateSort(scope.row.group_id,scope.row.goods_id,1)"
                size="medium"
                type="text"
                icon="el-icon-upload2"
                style="font-size:18px"
              ></el-button>

              <el-button
                @click="updateSort(scope.row.group_id,scope.row.goods_id,4)"
                size="medium"
                type="text"
                icon="el-icon-download"
                style="font-size:18px"
              ></el-button>

              <el-button
                @click="updateSort(scope.row.group_id,scope.row.goods_id,2)"
                size="medium"
                type="text"
                icon="el-icon-top"
                style="font-size:18px"
              ></el-button>
              <el-button
                @click="updateSort(scope.row.group_id,scope.row.goods_id,3)"
                size="medium"
                type="text"
                icon="el-icon-bottom"
                style="font-size:18px"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import healthmall from '../../../api/healthmall';
import platform from '../../../api/platform';

export default {
  data() {
    return {
      detail: {},
      edit: false,
      tableData: [],
      options: [],
      group_id: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      Selection: [],
      editdialog: false,
      choose_id: ''
    };
  },

  methods: {
    //获取健康商城商品类型列表
    getGroup() {
      healthmall.getGoodsGroupList().then((res) => {
        if (res.code == 0) {
          this.options = res.data.list;
        }
      });
    },
    //获取商品列表
    getGoods() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        group_id: this.group_id.toString()
      };
      healthmall.getGoodsList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getGoods();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGoods();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getGoods();
    },
    handleSelectionChange(val) {
      this.Selection = val.map((item) => {
        return item.goods_id;
      });
    },
    //排序
    updateSort(group_id, goods_id, sort) {
      let data = {
        group_id,
        goods_id,
        sort
      };
      healthmall.editGoodsSort(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('组内排序设置成功');
          this.getGoods();
        }
      });
    },
    //分组
    editGroup() {
      if (!this.Selection.length) {
        this.$message.error('请选择需要操作的商品');
        return false;
      }
      this.getGroup();
      this.editdialog = true;
    },
    //选择分组
    choose(group_id, index) {
      this.choose_id = group_id;
      let arr = document.getElementsByClassName('item');
      let num = this.options.length;
      for (let i = 0; i < num; i++) {
        arr[i].style.background = '#fff';
      }
      arr[index].style.background = '#ccc';
    },
    //提交商品分组
    submit() {
      this.editdialog = false;
      let goods_id = this.Selection.toString();
      let group_id = this.choose_id;
      healthmall.moveGoodsToGroup({ group_id, goods_id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('商品分组成功');
          this.getGoods();
        }
      });
    }
  },
  created() {
    this.getGroup();
    this.getGoods();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding: 20px;
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;
}
.grouplist {
  padding: 20px 30px 0px;
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .item {
    display: flex;
    justify-content: space-between;
    height: 30px;
    align-items: center;
    padding: 0 20px;
    &:hover {
      background: #ccc;
    }
  }
}
</style>

